import wxEnvir from './../wxEnvironment/wxEnvir'

export const util = {
    /**
    * 判断系统以及浏览器，返回一个二位数字
    * 首位:  1: android; 2: iphone;  3: ipad;
    * 第二位: 1: 酷狗内嵌; 2: 微信内嵌; 3: qq内嵌页; 4: 微博内嵌; 5: 繁星内嵌页; 6: 短酷;
    * 
    * 比如：11 - 安卓酷狗内嵌页
    */
    getSysBowser: () => {
        let ls = new Array(2);
        const ua = navigator.userAgent.toLocaleLowerCase();

        const uaMatch = function (reg) {
            return ua.match(reg);
        };

        // 判断系统
        if (uaMatch(/android/i)) {
            ls[0] = 1;
        } else if (uaMatch(/iphone/i) || uaMatch(/ios/i) || uaMatch(/KGBrowser/i)) {
            ls[0] = 2;
        } else if (uaMatch(/ipad/i)) {
            ls[0] = 3;
        } else {
            ls[0] = 4;
        }
        // 判断浏览器
        if (uaMatch(/kgbrowser/gi) || util.safeGetJson(window, 'external', 'superCall')) {
            // 酷狗app
            ls[1] = 1;
        } else if (uaMatch(/micromessenger/gi) && !uaMatch(/wxwork/gi)) {
            ls[1] = 2; // wechat && 不是企业微信
        } else if (uaMatch(/android/i) && uaMatch(/qq/gi) && uaMatch(/mqqbrowser/gi)) {
            // Android: QQ 的 ua 中有关键字 MQQBrowser，并且后面有一个 QQ 字符，QQ浏览器则没有
            ls[1] = 3; // qq
        } else if ((uaMatch(/iphone/i) || uaMatch(/ipad/i) || uaMatch(/ios/i)) && uaMatch(/ qq/gi)) {
            // iOS: QQ 的 ua 包含一个空格加QQ，但是不包含 MQQBrowser; QQ浏览器 ua 包含 MQQBrowser 但是不包含单独的 QQ
            ls[1] = 3; // qq
        } else if (uaMatch(/weibo/gi)) {
            ls[1] = 4; // weibo
        } else if (uaMatch(/fanxing/gi)) {
            ls[1] = 5; // fanxing
        } else if (uaMatch(/kgshortvideo/gi)) {
            ls[1] = 6; // 短酷
        } else {
            ls[1] = 100; // 其他
        }
        return ls;
    },

    /**
     * 安全得到 json
     * 
     * @param {*} json 
     */
    safeGetJson: (...json) => {
        try {
            let _len = json.length;
            let arr = new Array(_len > 1 ? _len - 1 : 0);

            for (let _key = 1; _key < _len; _key++) {
                arr[_key - 1] = json[_key];
            }

            return arr.reduce(function (totle, para) {
                return totle[para];
            }, json);
        } catch (e) {
            return 0;
        }
    },

    // 动态加载 js || jsonp
    jsonp: (url, callback) => {
        return new Promise((resolve, reject) => {
            const callbackName = "jsonCallBack" + parseInt(Math.random() * (999999999 - 0 + 1) + 0, 10);
            window[callbackName] = (result) => {
                callback && callback(result)
            }
            var JSONP = document.createElement("script");
            JSONP.type = "text/javascript";
            JSONP.src = `${url}&callback=${callbackName}`;
            document.getElementsByTagName("head")[0].appendChild(JSONP);
            setTimeout(() => {
                document.getElementsByTagName("head")[0].removeChild(JSONP);
            }, 1000);
        })
    },

    /**
     * 初始化微信环境
     */
    initWXSign: (callback) => {
        wxEnvir.init(() => {
            callback && callback();
        })
    }
}